import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { logout } from '../../../../actions/auth';
import { backendHOST } from '../../../../client-config/client-config';
import { withRouter } from '../../../hooks/withRouter';
import BalanceReportBase from './Balances/FormBalances';

const url = `${backendHOST}/api/scriptantiaAdmin`;

const FormTeacherBalance = ({ auth }) => {
  const buildParams = (active) => {
    const params = {
      active,
    };

    if (!auth.user.permissions.includes('balance.allOktato')) {
      params.oktato = auth.user.ext_id_user;
    }
    return params;
  };

  return (
    <BalanceReportBase
      title='Oktató egyenlegek'
      description='Oktatói pénzmozgások és egyenlegek riportja.'
      endpoint={`${url}/TeacherBalance`}
      buildParams={buildParams}
      groupField='tanar.text2'
      groupLabel='Oktató'
      secondGroupField='year'
      secondGroupLabel='Év'
      activeField='tanar.active'
      amountField='dij'
      descriptionField='descr'
      showPaymentMethod
      showInvoiceNumber={false}
      paymentButtonText='Kifizetés rögzítése'
    />
  );
};

FormTeacherBalance.propTypes = {
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { logout })(
  withRouter(FormTeacherBalance),
);
